import moment from 'moment-timezone';

export const formatDateIso = (timestamp: number, timezone: string = 'UTC'): string => {
    return moment
        .utc(timestamp * 1000)
        .tz(timezone)
        .format('YYYY-MM-DD');
};

export const formatDateIsoUtc = (timestamp: number): string => {
    return `${formatDateIso(timestamp)} (UTC)`;
};

export const formatDateIsoOrBlank = (timestamp?: number, timezone?: string): string => {
    return timestamp ? formatDateIso(timestamp, timezone) : '';
};

export const toEpochSeconds = (date: string | Date, timezone?: string): number => {
    if (timezone) {
        return moment.tz(date, timezone).unix();
    }
    return new Date(date).getTime() / 1000;
};

export const formatTimestampCompact = (): string => moment().format('YYYYMMDDHHmmss');

// Today in the viewer's local zone, not UTC, so "not before today" matches the reseller's calendar.
export const todayIsoDate = (): string => moment().format('YYYY-MM-DD');

/**
 * Converts a timestamp value (seconds or milliseconds) to milliseconds.
 * Values below 1e12 are assumed to be in seconds and are multiplied by 1000.
 */
export const toMilliseconds = (value: string | number): number => {
    const numValue = typeof value === 'number' ? value : Number(value);
    return numValue < 1e12 ? numValue * 1000 : numValue;
};
